import {IBook, IQuiz,IVerse,IQuestion} from '../model/Interfaces';
import axios from 'axios';

export async function getBooks():Promise<IBook[]>{
    return await axios.get<IBook[]>('https://beeibeeli.org/quiz/books/', {maxRedirects: 0})
        .then(response =>{
            return response.data;
        })
        .catch( error => {
            console.dir(error);
            return [];
        });
}

export async function getQuiz(book:string,chapters:number[],limit:number):Promise<IQuiz>{
    let chapterList = '';

    if (chapters != null) { chapterList = chapters.join(',')};

    return await axios.get<IQuiz>('https://beeibeeli.org/quiz/build/'+book+'/'+chapterList+'/'+limit, {maxRedirects: 0})
        .then(response =>{
            return response.data;
        })
        .catch( error => {
            console.dir(error);
            return {Questions: Array<IQuestion>(), Verses: Array<IVerse>()};
        });
    
    
}